/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DomainService as BoLankaContractDomainService } from '../models/BoLanka/Contract/domain-service';
import { SetPrvServiceRequest as BoLankaContractSetPrvServiceRequest } from '../models/BoLanka/Contract/set-prv-service-request';

@Injectable({
  providedIn: 'root',
})
export class ProviderServiceService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiRoutesTrmIdProviderPrvIdServiceGet
   */
  static readonly ApiRoutesTrmIdProviderPrvIdServiceGetPath = '/api/routes/{trmId}/provider/{prvId}/service';

  /**
   * ### Claim
   *  boservice.routes.listprvservice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoutesTrmIdProviderPrvIdServiceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoutesTrmIdProviderPrvIdServiceGet$Response(params: {
    lang?: string;
    trmId: number;
    prvId: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<BoLankaContractDomainService>>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderServiceService.ApiRoutesTrmIdProviderPrvIdServiceGetPath, 'get');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.path('trmId', params.trmId, {});
      rb.path('prvId', params.prvId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BoLankaContractDomainService>>;
      })
    );
  }

  /**
   * ### Claim
   *  boservice.routes.listprvservice
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoutesTrmIdProviderPrvIdServiceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoutesTrmIdProviderPrvIdServiceGet(params: {
    lang?: string;
    trmId: number;
    prvId: number;
  },
  context?: HttpContext

): Observable<Array<BoLankaContractDomainService>> {

    return this.apiRoutesTrmIdProviderPrvIdServiceGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<BoLankaContractDomainService>>) => r.body as Array<BoLankaContractDomainService>)
    );
  }

  /**
   * Path part for operation apiRoutesTrmIdProviderPrvIdServicePut
   */
  static readonly ApiRoutesTrmIdProviderPrvIdServicePutPath = '/api/routes/{trmId}/provider/{prvId}/service';

  /**
   * ### Claim
   *  boservice.routes.setprvservice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoutesTrmIdProviderPrvIdServicePut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoutesTrmIdProviderPrvIdServicePut$Response(params: {
    trmId: number;
    prvId: number;
    lang?: string;
    body?: BoLankaContractSetPrvServiceRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderServiceService.ApiRoutesTrmIdProviderPrvIdServicePutPath, 'put');
    if (params) {
      rb.path('trmId', params.trmId, {});
      rb.path('prvId', params.prvId, {});
      rb.query('lang', params.lang, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * ### Claim
   *  boservice.routes.setprvservice
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoutesTrmIdProviderPrvIdServicePut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoutesTrmIdProviderPrvIdServicePut(params: {
    trmId: number;
    prvId: number;
    lang?: string;
    body?: BoLankaContractSetPrvServiceRequest
  },
  context?: HttpContext

): Observable<void> {

    return this.apiRoutesTrmIdProviderPrvIdServicePut$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
